
/**
 * 콘텐츠 유형
 */
export type GetLectureDetail200ResponseContentType = typeof GetLectureDetail200ResponseContentType[keyof typeof GetLectureDetail200ResponseContentType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetLectureDetail200ResponseContentType = {
  VIDEO: 'VIDEO',
  ARTICLE: 'ARTICLE',
  QUIZ: 'QUIZ',
  ASSIGNMENT: 'ASSIGNMENT',
} as const;
